import React from 'react';

import {
  Header,
} from 'semantic-ui-react';

import { sanitizeHtmlContent } from '../utils/utils'

export default function ContentHeadline(props) {
  //console.log('ContentHeadline - props', props);

  const {
    variationType,
    sticky,
    textAlign,
    preheader,
    content,
    subheader,
    maxWidth,
  } = props;

  //const textColor = props.text_color ? props.text_color : props.header_text_color ? props.header_text_color : null;
  
  return (
    <>
      {/* <style dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize([
          '#layout-wrapper a.ui.button.postUpSignUpButton {',
          '  color: '+ textColor +';',
          '  box-shadow: inset 0 0 0 2px '+ textColor +' !important;',
          '}',
          '#layout-wrapper a.ui.button.postUpSignUpButton:hover {',
          '  color: '+ props.header_background_color +' !important;',
          '  background: '+ textColor +' !important;',
          '}'
          ].join('\n'))
        }}>
      </style> */}
      <div className={'site-content-headline'+ (sticky ? ' sticky' : '')} style={{ maxWidth: (maxWidth ? maxWidth : null), }}>
        {preheader ?
          <Header sub
            textAlign={textAlign !== 'unset' ? textAlign : null}
          >
            {preheader}
          </Header>
        :
          null
        }
        <Header as={variationType ? variationType : null}
          textAlign={textAlign !== 'unset' ? textAlign : null}
        >
          {content && content.html ?
            <div dangerouslySetInnerHTML={{__html: sanitizeHtmlContent(content.html)}}></div>
          :
            null
          }
          {subheader ?
            <Header.Subheader className={textAlign !== 'unset' ? textAlign : null}>
              {subheader}
            </Header.Subheader>
          :
            null
          }
        </Header>
      </div>
    </>
  )
}
